"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Row selection feature for InfiniTable.
 *
 * Enable via allowSelection : true if the configuration.
 *
 * Properties :
 *      - allowSelection [true/false] set to true to enable feature.
 *      - selectionAttribute
 *      - selectionScope
 */
ngModule.factory("itRowSelectionFeature", function (itUtils) {
  return function itRowSelectionFeature(tableCtrl) {
    var feature = this,
      ctrl = tableCtrl,
      $scope = tableCtrl.getScope(),
      rowSelection = null,
      selectionScope = null,
      selectionAccessor = null;
    feature.enable = function () {
      initializeRowSelection();
    };
    feature.getRowSelection = function () {
      return rowSelection;
    };
    feature.getRowSelectionIndex = function () {
      var renderer = ctrl.getRenderer(),
        dataSource = renderer.getActualSource(),
        rowSelection = feature.getRowSelection();
      var actualIdx = _.indexOf(dataSource, rowSelection);
      // pour les tree
      if (actualIdx === -1 && rowSelection && ctrl.getConfig().type === 'tree') {
        var idx = 0;
        _.each(dataSource, function (d) {
          if (d.nodeId && rowSelection.nodeId && d.nodeId === rowSelection.nodeId || d.model === rowSelection) {
            actualIdx = idx;
          }
          idx++;
        });
      }
      return actualIdx;
    };
    feature.selectRow = function (idx) {
      // todo : or model ?
      var renderer = ctrl.getRenderer(),
        dataSource = renderer.getActualSource();
      setSelectedModel(dataSource[idx]);
    };
    feature.selectNextRow = function () {
      var renderer = ctrl.getRenderer(),
        dataSource = renderer.getActualSource(),
        actualIdx = _.indexOf(dataSource, rowSelection);

      // pour les tree
      if (actualIdx === -1 && ctrl.getConfig().type === 'tree') {
        var idx = 0;
        _.each(dataSource, function (d) {
          if (d.nodeId === rowSelection.nodeId
          // necessaire car le click met directement le model
          || d.model === rowSelection) {
            actualIdx = idx;
          }
          idx++;
        });
      }
      if (actualIdx < dataSource.length - 1) {
        setSelectedModel(dataSource[actualIdx + 1]);
        return true;
      } else {
        return false;
      }
    };
    feature.selectPreviousRow = function () {
      var renderer = ctrl.getRenderer(),
        dataSource = renderer.getActualSource(),
        actualIdx = _.indexOf(dataSource, rowSelection);

      // pour les tree
      if (actualIdx === -1 && ctrl.getConfig().type === 'tree') {
        var idx = 0;
        _.each(dataSource, function (d) {
          if (d.nodeId === rowSelection.nodeId
          // necessaire car le click met directement le model
          || d.model === rowSelection) {
            actualIdx = idx;
          }
          idx++;
        });
      }
      if (actualIdx > 0) {
        setSelectedModel(dataSource[actualIdx - 1]);
        return true;
      } else {
        return false;
      }
    };
    function setSelectedModel(model) {
      rowSelection = model;
      selectionAccessor(model);
    }

    // TODO : feature.disable

    function initializeRowSelection() {
      var config = ctrl.getConfig();
      selectionScope = config.selectionScope || $scope.$parent;
      if (!config.selectionAttribute) {
        console.error('pas de selectionAttribute de défini sur la configuration', config);
        // on en défini un par defaut pour que la selection des lignes fonctionne quand meme.
        config.selectionAttribute = "defautSelectionAttribute";
      }
      selectionAccessor = itUtils.createAccessor(selectionScope, config.selectionAttribute);

      // initialize the selection row value in case of preselection
      rowSelection = selectionAccessor();

      // click on a row -> we select the row.
      ctrl.ui.contentBody.delegate("tr", "click", function (event) {
        var row = $(event.currentTarget);
        var model = row.scope().model;
        selectionScope.$apply(function () {
          var currentSelection = selectionAccessor();
          if (currentSelection === model) {
            // TODO : apply probably useless in that case.
            return;
          }
          if (config.type === 'tree') {
            var renderer = ctrl.getRenderer(),
              dataSource = renderer.getActualSource();
            _.each(dataSource, function (d) {
              if (d.model === model) {
                model = d.model;
              }
            });
          }
          selectionAccessor(model);
        });
      });
      $scope.$watch(function () {
        return selectionAccessor();
      }, function (selection) {
        rowSelection = selection;
      });

      /**
       * Wire a getter for this feature on the table controller.
       */
      ctrl.getSelectionFeature = function () {
        return feature;
      };

      /**
       * Returns the currently selected row model.
       */
      ctrl.getRowSelection = function () {
        return rowSelection;
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/common/itRowSelectionFeature.js
// module id = 2802
// module chunks = 13